
import React from 'react';

interface HorizontalScrollerProps {
  children: React.ReactNode;
  noLeftPadding?: boolean;
  showNextCard?: boolean;
  snap?: boolean;
  snapAlign?: 'start' | 'center';
  snapStopAlways?: boolean;
  spacing?: 'sm' | 'md' | 'lg' | 'custom-10px' | 'custom-5px' | 'custom-2px';
  disableScale?: boolean;
}

const HorizontalScroller: React.FC<HorizontalScrollerProps> = ({ 
  children,
  noLeftPadding = false,
  showNextCard = true,
  snap = false,
  snapAlign = 'start',
  snapStopAlways = true,
  spacing = 'md',
  disableScale = false,
}) => {
  const spacingClass =
    spacing === 'sm'
      ? 'gap-x-2'
      : spacing === 'lg'
      ? 'gap-x-4'
      : spacing === 'custom-10px'
      ? 'gap-x-[10px]'
      : spacing === 'custom-5px'
      ? 'gap-x-[5px]'
      : spacing === 'custom-2px'
      ? 'gap-x-[2px]'
      : 'gap-x-3';
  const scrollPaddingClass = snap ? (noLeftPadding ? '' : 'scroll-px-4') : '';
  const scaleClass = (disableScale || snap) ? '' : 'transform scale-90 origin-left';
  return (
    <div 
      className={`flex overflow-x-auto py-0 scrollbar-hide mb-4 ${spacingClass} ${noLeftPadding ? 'pl-0' : 'pl-4'} ${snap ? `snap-x snap-mandatory overscroll-x-contain ${scrollPaddingClass}` : ''} ${showNextCard ? 'pr-[10%]' : ''}`}
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch'
      }}
      onScroll={(e) => {
        // Ensure no extra scroll snapping jitter on iOS
      }}
    >
      {React.Children.map(children, (child) => 
        React.isValidElement(child)
          ? React.cloneElement(child, {
              ...child.props,
              className: `${child.props.className || ''} ${scaleClass} ${snap ? `flex-shrink-0 ${snapAlign === 'center' ? 'snap-center' : 'snap-start'} ${snapStopAlways ? 'snap-always' : ''}` : ''}`.trim()
            })
          : child
      )}
    </div>
  );
};

export default HorizontalScroller;
